import {ScormUtils} from "scorm/common/ScormUtils";
import {Assert} from "common/Assert";
import {Event} from "common/Event";
import {CourseEvents} from "course/CourseEvents";

/***********************************************************************
 scorm api 1.2 for ttkf player (html4 and html5) to collect lesson sco
 data and provide it to the lms as a single sco
 ***********************************************************************/
export function CreScormApi( activeSco, courseApi ){

    Assert.checkArgument( activeSco );
    Assert.checkArgumentType( activeSco.getValue, "function" );
    Assert.checkArgumentType( activeSco.setValue, "function" );

    Assert.checkArgument( courseApi );
    Assert.checkArgumentType( courseApi.getValue, "function" );
    Assert.checkArgumentType( courseApi.setValue, "function" );
    Assert.checkArgumentType( courseApi.commit, "function" );
    Assert.checkArgumentType( courseApi.getLastError, "function" );
    Assert.checkArgumentType( courseApi.getErrorString, "function" );
    Assert.checkArgumentType( courseApi.getDiagnostic, "function" );

    let initialized = false;

    // revealing public api
    return {

        /***********************************************************************
         initializes the communication with the course
         @return {String} true / false
         ***********************************************************************/
        LMSInitialize: function() {

            if( initialized ){
                return "false";
            }

            initialized = true;

            return "true";
        },

        /***********************************************************************
         terminates the communication with the course
         @return {String} true / false
         ***********************************************************************/
        LMSFinish: function() {
            console.log("CreScormApi::LMSFinish()");
            Event.trigger( document, CourseEvents.SEQUENCE_TERMINATED, { scoId : activeSco.getId() } );
            return "true";
        },

        /***********************************************************************
         gets a value from course sco repository or the lms
         @param {String} dataModelId scorm data model id for the the value
         @return {String} true / false
         ***********************************************************************/
        LMSGetValue: function( dataModelId ) {
            switch (dataModelId) {
                case "cmi.core._children":
                    return ScormUtils.insertChildren(courseApi.getValue(dataModelId), "lesson_location,lesson_status,lesson_mode,entry,score");
                case "cmi.core.score._children":
                    return ScormUtils.insertChildren(courseApi.getValue(dataModelId), "raw");
                case "cmi.core.entry":
                    return "ab-initio";
                case "cmi.core.lesson_location":
                case "cmi.core.lesson_status":
                case "cmi.core.lesson_mode":
                case "cmi.core.score.raw":
                case "cmi.suspend_data":
                    return activeSco.getValue(dataModelId);
                default:
                    return courseApi.getValue(dataModelId);
            }
        },

        /***********************************************************************
         sets a value in the course sco repository or the lms
         @param {String} dataModelId scorm data model id for the the value
         @param {String} value value data
         @return {String} true / false
         ***********************************************************************/
        LMSSetValue: function (dataModelId, value) {
            switch (dataModelId) {
                case "cmi.core.lesson_location":
                case "cmi.core.lesson_status":
                case "cmi.core.entry":
                case "cmi.core.session_time":
                case "cmi.suspend_data":
                    activeSco.setValue( dataModelId, value );
                    return "true";
                case "cmi.core.score.raw":
                    const score = ScormUtils.getImprovedScore( value, activeSco.getValue( "cmi.core.score.raw" ) );
                    if( score ){
                        activeSco.setValue( "cmi.core.score.raw", score );
                    }
                    return "true";

                case "cmi.core._children":
                case "cmi.core.score._children":
                case "cmi.student_data.mastery_score":
                case "cmi.core.credit":
                    return "false";

                default:
                    return "true";
            }
        },

        /***********************************************************************
         commits the data to the course
         @param {String} parameter does nothing, exists due to scorm support
         @return {String} true / false
         ***********************************************************************/
        LMSCommit: courseApi.commit,

        /***********************************************************************
         checks errors for previous calls
         @return {String} 0 or error code
         ***********************************************************************/
        LMSGetLastError: courseApi.getLastError,

        /***********************************************************************
         gets an error message for errors raised in previous calls
         @param {String} errorCode
         @return {String} error message or empty string
         ***********************************************************************/
        LMSGetErrorString: courseApi.getErrorString,

        /***********************************************************************
         gets an diagnostic message for errors raised in previous calls
         @param {String} errorCode
         @return {String} diagnostic message or empty string
         ***********************************************************************/
        LMSGetDiagnostic: courseApi.getDiagnostic
    };
}
